import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  PaginationTotalStandalone
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Select from "react-select";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import { AvForm,AvField } from "availity-reactstrap-validation";
import { Button, Card, CardBody, Col, Container, Row} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../../helpers/Baseurl"
import "../../../assets/scss/datatables.scss"
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import default_img from '../../../assets/images/noimg.jpeg'

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const customStyles = {
    overlay: {
        marginTop: '70px'
    }
}

const FilterOptions = [
  { 
		label: "Filter Options",
		options: [
              { label: "Name", value: '1' },
              { label: "Brand", value: '2' },
              { label: "Vehicle Type", value: '3' },         
		]
	}
]

class Vehicles extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 2, 'read' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      vehicle_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",

      vehicles: [],
      brandGroup: [],
      TypeGroup: [],

      page:1,
      sizePerPage:20,
      totalSize:0,
      searchText:"",

      selectedFilterOptions: { label: "Filter By ", value: null },
      selectedBrandType:  { label: "Select Brand", value: null },
      selectedType: { label: "Select Type", value: null },
      filter_option:"",

      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "Vehicles", link : "#" },
    ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleVehicleClicks = this.handleVehicleClicks.bind(this)
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this)
    this.clearFilter = this.clearFilter.bind(this)
  }
  componentDidCatch(error) {
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  componentDidMount(){
    document.title = `Vehicles | Planmans`
    this.loadBrandData()
    this.loadVehicleTypeData()
  }

  // Get All Vehicles 
  async loadData(url , sizePerPage, page , searchText){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(url,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState(()=>({ vehicles: data.results, totalSize:data.count , page:page, sizePerPage, searchText }))
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }

  async loadBrandData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(comp => {
                  options.push({ label: comp.name, value: comp.id })
                })
                let brandGroup = [
                  { 
                    label: "Brands",
                    options: options
                  }
                ];
                this.setState({ brandGroup: brandGroup })           
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
 }

 async loadVehicleTypeData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(comp => {
                options.push({ label: comp.name, value: comp.id })
              })
              let TypeGroup = [
                { 
                  label: "Vehical Type",
                  options: options
                }
              ];
              this.setState({ TypeGroup: TypeGroup, })           
            
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }
  handleFilterSubmit(e, values){
    const {sizePerPage, selectedFilterOptions, selectedBrandType, selectedType} = this.state
    let filter_option = ""
    if(selectedFilterOptions.value === '2'){
      if (selectedBrandType.value === null){
        toastr.error("Select Brand", "")
      }else{
        filter_option = `&brand__id=${selectedBrandType.value}`
        let url = `${BaseUrl}/api/vehicles/vehicle/?size=${sizePerPage}&page=1${filter_option}` 
        this.loadData(url , sizePerPage, 1 , "")
      }

    }else if(selectedFilterOptions.value === '3'){
      if (selectedType.value === null){
        toastr.error("Select Vehicle Type", "")
      }else{
        filter_option = `&vehicle_type__id=${selectedType.value}`
        let url = `${BaseUrl}/api/vehicles/vehicle/?size=${sizePerPage}&page=1${filter_option}`  
        
        this.loadData(url , sizePerPage, 1 , "")
      }

    }else if(selectedFilterOptions.value === '1'){
      
      filter_option = `&search=${values.name}`
      let url = `${BaseUrl}/api/vehicles/vehicle/?size=${sizePerPage}&page=1${filter_option}` 
      this.loadData(url , sizePerPage, 1 , "")
   

    }
    this.setState({filter_option})

  }

//  method for Clear all search and filter 
  clearFilter(){
    let selectedFilterOptions={ label: "Filter By ", value: null }
    this.setState({selectedFilterOptions})
    let url = `${BaseUrl}/api/vehicles/vehicle/?size=${this.state.sizePerPage}&page=1`
    this.loadData(url , this.state.sizePerPage, 1 , "")
  }
  // Create Selected Vehicle Copy  
  handleCopyVehicle = id => {
    let data = {"vehicle_id":id}
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/vehicles/copy-added-vehicle/`,requestOptions)
          .then(res => 
              {if(res.status >= 400){
                  res.json()
                  .then(
                      (data) =>{  
                          console.log(data, "---data")
                          toastr.error("Something Went Wrong", "")
                          this.setState({
                            vehicle_id:"",
                            copy_success_confirm: false,
                            copy_alert_confirm : false,
                            }) 
                      }    
                  )
              }
              else{
                let url = `${BaseUrl}/api/vehicles/vehicle/?size=${this.state.sizePerPage}&page=${1}`
                this.loadData(url , this.state.sizePerPage, 1 , "")
                  this.setState({
                    vehicle_id:"",
                    copy_success_confirm: true,
                    copy_alert_confirm : false,
                    dynamic_title: "Copied!",
                    dynamic_description: "Your vehicle has been Copied."
                    })
              }    
          }
      )

  }

  // Delete Selected Vehicle 
  handleVehicleClicks = id => {    

    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/vehicles/vehicle/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    let new_page = this.state.page
                    if(this.state.vehicles.length < 2){
                      new_page = new_page>1? new_page-1:1
                    }
                    let url = `${BaseUrl}/api/vehicles/vehicle/?size=${this.state.sizePerPage}&page=${new_page}`
                    url = this.state.searchText && this.state.searchText !== "" ? url+`&search=${this.state.searchText}`: url
                    this.loadData(url , this.state.sizePerPage, new_page , this.state.searchText)
                    this.setState({
                      vehicle_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Your vehicle has been deleted."
                      })  
                  }
              }
          )
  }
  // Override Bootstrap Table method handleTableChange for add Pagination and Search API 
  handleTableChange = (type, { page, sizePerPage, searchText, sortField, sortOrder }) => {
    
    setTimeout(() => {

      let new_page = page
      let url = `${BaseUrl}/api/vehicles/vehicle/?size=${sizePerPage}&&page=${new_page}`
      if (searchText && this.state.searchText !== ""){
        new_page = this.state.searchText !== searchText? 1 : new_page
        url = `${BaseUrl}/api/vehicles/vehicle/?size=${sizePerPage}&page=${new_page}&search=${searchText}`
      }
      this.loadData(url , sizePerPage, new_page , searchText)
    }, 1000);
  }

  render() {

    const { vehicles, page, sizePerPage, totalSize, selectedFilterOptions } = this.state

    //pagination customization
    const pageOptions = {
      page: page,
      sizePerPage: sizePerPage,
      totalSize: totalSize, 
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const VehiclesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        formatter: (cellContent, row) => (
          `V-${row.id+100}`    
        )
      },
      {
        dataField: "images",
        text: "Image",
        isDummyField: true,
        formatter: (cellContent, row) => (
          row.images.length === 0?
          <img className="rounded avatar-sm" src={default_img} alt={row.name} /> :
          <img className="rounded avatar-sm" src={BaseUrl+row.images[0].image} onClick={() => this.setState({ isFits: true, img_src:BaseUrl+row.images[0].image, img_name:row.name  })} alt={row.name}/>
          )

      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
          has_Permission(this.obj.user, 2, 'edit') ?
            <a 
              href={`/edit-vehicle/${row.id}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="me-3 text-dark"
            >
              {row.name}
            </a>
          : cellContent
        )
      },      
      {
        dataField: "brand.name",
        text: "Brand",
        sort: true,

      },
      {
        dataField: "model",
        text: "Model",
        sort: true,

      },
      {
        dataField: "year",
        text: "Year",
        sort: true,

      },
      {
        dataField: "vehicle_type.name",
        text: "Vehicle Type",
        sort: true,

      },
      {
        dataField: "created_by",
        text: "Created By",
        formatter: (cellContent, row) => (
          row.created_by?row.created_by.first_name+" "+row.created_by.last_name:"-"
        )
      },
            
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link  to="#" onClick={() => this.props.history.push(`/vehicle/${row.id}`)} className="me-3 text-secondary"><i className="mdi mdi-eye font-size-18"></i></Link>
            {has_Permission(this.obj.user, 2, 'create' )?
              <Link  to="#" onClick={() => this.setState({ copy_alert_confirm: true, vehicle_id:row.id })} className="me-3 text-secondary"><i className="mdi mdi-content-copy font-size-18"></i></Link>
            :null}
            {has_Permission(this.obj.user, 2, 'delete' )?
              <Link to="#" onClick={() => this.setState({ alert_confirm: true, vehicle_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            :null}
            </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
        {this.state.isFits ? (
          <Lightbox
            reactModalStyle = {customStyles}
            mainSrc={this.state.img_src}
            enableZoom={false}
            imageCaption={
              `Image : ${this.state.img_name}`
            }
            onCloseRequest={() => this.setState({ isFits: false })}
          />):null}
          
          <Container fluid>
          <Breadcrumbs title="All Vehicles" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={vehicles}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={vehicles}
                          columns={VehiclesColumns}
                          remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                               
                                <Col sm="9">
                                  <Row>
                                    <Col sm="3">
                                      <div className="mb-3 search-box" style={{borderRadius: "30px"}}>
                                          <Select  
                                              value= {selectedFilterOptions}
                                              onChange={(e) => this.setState({selectedFilterOptions: e})}
                                              options={FilterOptions}
                                              classNamePrefix="select2-selection"
                                          />
                                      </div>
                                    </Col>
                                    <Col sm="9">
                                      <AvForm className="needs-validation" onValidSubmit={this.handleFilterSubmit} >
                                        <Row>
                                          <Col sm="12">
                                            {selectedFilterOptions.value?
                                            <Row>
                                              {selectedFilterOptions.value==="2"?(
                                              <Col sm="6">
                                                <div className="mb-3 search-box" >
                                                    <Select  
                                                        
                                                        value= {this.state.selectedBrandType}
                                                        onChange={(e) => this.setState({selectedBrandType: e})}
                                                        options={this.state.brandGroup}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </div>
                                            </Col>
                                              ):(
                                              selectedFilterOptions.value==="3"?(
                                              <Col sm="6">
                                                <div className="mb-3 ">
                                                    <Select 
                                                        value= {this.state.selectedType}
                                                        onChange={(e) => this.setState({selectedType: e})}
                                                        options={this.state.TypeGroup}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </div>
                                            </Col>
                                              ):(selectedFilterOptions.value==="1"?
                                              (
                                                <Col md="6">
                                                  <div className="search-box mb-3">
                                                    <div className="position-relative">
                                                      <AvField
                                                        name="name"
                                                        placeholder={"Name"}
                                                        type="text"
                                                        errorMessage={"Enter Name"}
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="name"
                                                      />
                                                    </div>
                                                  </div>

                                                </Col>
                                                
                                              ):
                                                  null
                                             )
                                            
                                              
                                              )}
                                              <Col md="6">
                                                <div className="mb-2">
                                                  <Button type="submit" color="primary" className="btn-rounded me-1">
                                                  <i className="mdi mdi-filter-outline me-1" />
                                                    Apply Filter
                                                  </Button>{" "}
                                                  {this.state.filter_option!== ""?
                                                    <Button type="button" color="secondary" onClick={this.clearFilter} className="btn-rounded me-1">
                                                    <i className="mdi mdi-close me-1" />{" "}
                                                      Clear
                                                    </Button>
                                                  :null}
                                                </div>
                                              </Col> 
                                              
                                            </Row>
                                            :null}
                                
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </Col>

                                  </Row>   

                                </Col>
                                <Col sm="3">
                                  <div className="text-sm-end">
                                    {has_Permission(this.obj.user, 2, 'create' )?
                                      <Button
                                        type="button"
                                        color="success"
                                        className="btn-rounded mb-2 me-2"
                                        onClick={() => this.props.history.push("/new-vehicle")}
                                      >
                                        <i className="mdi mdi-plus me-1" />{" "}
                                        Add Vehicle
                                      </Button>
                                    :null}
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  remote
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                  columns = {VehiclesColumns}
                                  onTableChange={ this.handleTableChange }
                                  classes={
                                    "table align-middle table-nowrap"
                                  }
                                />
                                
                              </div>
                              <Row>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded mb-2">
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                </Col>
                              </Row>
                              {this.state.alert_confirm ? (
                                                    <SweetAlert
                                                    title="Are you sure?"
                                                    warning
                                                    showCancel
                                                    confirmBtnBsStyle="success"
                                                    cancelBtnBsStyle="danger"
                                                    onConfirm={() => this.handleVehicleClicks(this.state.vehicle_id)}
                                                    onCancel={() =>
                                                        this.setState({
                                                            alert_confirm: false,
                                                            vehicle_id:"",

                                                        })
                                                    }
                                                    >
                                                    You won't be able to revert this!
                                                    </SweetAlert>
                                                ) : null}

                              {this.state.success_confirm ? (
                                <SweetAlert
                                success
                                title={this.state.dynamic_title}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                >
                                    {this.state.dynamic_description}
                                </SweetAlert>
                                  )
                                  : null
                              }
                              {this.state.copy_alert_confirm ? (
                                                    <SweetAlert
                                                    title="Are you sure?"
                                                    warning
                                                    showCancel
                                                    confirmBtnBsStyle="success"
                                                    cancelBtnBsStyle="danger"
                                                    onConfirm={() => this.handleCopyVehicle(this.state.vehicle_id)}
                                                    onCancel={() =>
                                                        this.setState({
                                                            copy_alert_confirm: false,
                                                            vehicle_id:"",

                                                        })
                                                    }
                                                    >
                                                    You Really Want to replicate it !
                                                    </SweetAlert>
                                                ) : null}

                              {this.state.copy_success_confirm ? (
                                <SweetAlert
                                success
                                title={this.state.dynamic_title}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.setState({ copy_success_confirm: false, copy_alert_confirm : false })}
                                >
                                    {this.state.dynamic_description}
                                </SweetAlert>
                                  )
                                  : null
                              }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Vehicles